var N = (F, S, v) => new Promise((T, m) => {
  var I = (_) => {
    try {
      b(v.next(_));
    } catch (p) {
      m(p);
    }
  }, g = (_) => {
    try {
      b(v.throw(_));
    } catch (p) {
      m(p);
    }
  }, b = (_) => _.done ? T(_.value) : Promise.resolve(_.value).then(I, g);
  b((v = v.apply(F, S)).next());
});
import { u as _e, o as me } from "./use-offering-D7hYyekH.js";
import { u as ye } from "./use-cart-D8NOb7eE.js";
import { u as ge } from "./use-config-1FCHS5th.js";
import { u as he } from "./use-wishlist-DGdQdUnB.js";
import { s as ve, m as X, aq as ke, u as be, a as C, q as Y, o as pe, b as xe, c as s, e as o, f, l as O, g as a, h as y, F as h, t as n, k as r, p as w, w as V, i as W } from "./define-element-XpjsV6s1.js";
import { i as Z, d as ee } from "./utils-CMsllPx8.js";
import { f as U } from "./format-currency-D_QngrXg.js";
import { L as Ce } from "./LoaderProduct-DFGIZnm0.js";
import { L as we } from "./LoginForm-D68uOH8H.js";
import { P as Ue } from "./PromoCode-q3MmxwYM.js";
import { L as q } from "./Loader-CeIJU_1y.js";
import { B as qe } from "./Button-D5lKR5Sd.js";
import { S as D } from "./Select-CfkMpX3N.js";
import { _ as Se } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const Le = {
  class: "offset-offering",
  ref: "container"
}, Me = {
  key: 1,
  class: "offset-offering-login"
}, $e = { key: 2 }, Qe = {
  key: 0,
  class: "offset-offering-banner"
}, Oe = { class: "offset-offering-actions" }, Ve = ["disabled"], We = { class: "offset-offering-list" }, Fe = { class: "offset-offering-image" }, Te = ["src", "alt"], Ie = ["aria-label"], Pe = { class: "offset-offering-details" }, Re = {
  key: 0,
  class: "offset-offering-badge"
}, Be = { class: "offset-offering-name" }, ze = { key: 0 }, Ae = ["innerHTML"], Ne = ["innerHTML"], De = ["onClick"], He = {
  key: 3,
  class: "offset-offering-stock"
}, Ee = { class: "offset-offering-table" }, je = { key: 0 }, Ge = {
  key: 0,
  class: "offset-offering-na"
}, Je = ["value"], Ke = {
  key: 0,
  class: "offset-offering-qty-row"
}, Xe = ["value"], Ye = ["aria-label"], Ze = ["aria-label"], et = { key: 0 }, tt = {
  key: 0,
  class: "offset-offering-na"
}, st = ["value"], at = ["aria-label"], ot = {
  key: 1,
  class: "offset-offering-summary"
}, it = { class: "offset-offering-summary-subtotal" }, lt = { key: 0 }, nt = { key: 1 }, ft = {
  key: 1,
  class: "offset-offering-summary-discount"
}, rt = { key: 0 }, ut = { key: 1 }, dt = { class: "offset-offering-summary-actions" }, ct = {
  __name: "Offering",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    // Left unset by default so the type-aware getCheckoutUrl() fallback (see
    // checkoutUrlResolved below) applies — pass an explicit checkout-url
    // attribute to override it. Since this component itself sets the page's
    // cart type to "offering" below, the fallback naturally resolves to
    // checkoutOfferingUrl.
    checkoutUrl: {
      type: String,
      default: ""
    }
  },
  setup(F) {
    const S = F;
    ve("offering");
    const v = X(() => S.checkoutUrl || ke()), { isPending: T, offeringProducts: m, authRequired: I } = _e(), { cart: g, loadCart: b, updateQuantity: _, addToCart: p, clearCart: te, isUpdatingCart: H, isUpdatingQuantityInCart: E } = ye(), { config: se } = ge(), { wish: ae, isSavingWish: oe, fetchWish: j, updateWishlistQuantity: ie } = he(), le = be("container"), d = C({}), x = C({}), L = C({}), M = C(!1), P = {};
    function ne(t, i) {
      P[t] || (P[t] = ee((e) => _(t, e, { showSideCart: !1 }), 500)), P[t](i);
    }
    const R = {};
    function fe(t, i) {
      R[t] || (R[t] = ee((e) => ie(t, e), 500)), R[t](i);
    }
    me(() => j());
    function re(t) {
      window.location = t;
    }
    const $ = X(() => {
      var t;
      return ((t = g.value.items) != null ? t : []).reduce((i, e) => i + (e.quantity || 0), 0);
    }), G = C(!1);
    Y([m, G], ([t, i]) => {
      var e;
      if (i)
        for (const u of t) {
          u.sku in d.value || (d.value[u.sku] = u.cartQty);
          for (const k of (e = u.variants) != null ? e : [])
            k.sku in d.value || (d.value[k.sku] = k.cartQty);
        }
    }, { immediate: !0 }), Y(ae, (t) => {
      for (const i in t)
        i in x.value || (x.value[i] = t[i].quantity);
    }, { immediate: !0 });
    function J(t, i, e) {
      const u = Math.max(0, Math.min(e, parseInt(i, 10) || 0));
      d.value[t] = u, ne(t, u);
    }
    function ue(t, i, e) {
      const u = Math.max(0, Math.min(e, parseInt(i, 10) || 0));
      x.value[t] = u, fe(t, u);
    }
    function de() {
      return N(this, null, function* () {
        M.value = !0;
        try {
          yield te();
          for (const t of m.value) {
            if (t.quantity < 1 || t.status_availability === "Inactive") {
              console.warn(
                `Skipping ${t.sku} in Add Full Offering: quantity=${t.quantity}, status_availability=${t.status_availability}`
              );
              continue;
            }
            yield p(t.sku, t.quantity, { showSideCart: !1 });
          }
          for (const t of m.value)
            d.value[t.sku] = t.cartQty;
        } catch (t) {
          console.error("Failed to add full offering to cart:", t);
        } finally {
          M.value = !1;
        }
      });
    }
    function ce(t) {
      L.value[t] = !L.value[t];
    }
    function B(t, i) {
      return i > 0 ? `${t} of ${i}` : String(t);
    }
    function z(t) {
      return Array.from({ length: t + 1 }, (i, e) => e);
    }
    return pe(() => N(null, null, function* () {
      xe(le.value, S.inheritStyle), j(), yield b(), G.value = !0;
    })), (t, i) => (s(), o("div", Le, [
      f(T) ? (s(), O(Ce, {
        key: 0,
        count: 3
      })) : f(I) ? (s(), o("div", Me, [
        i[1] || (i[1] = a("p", null, "Please log in to view your allocation.", -1)),
        y(we, { "redirect-url": "" })
      ])) : f(m).length ? (s(), o(h, { key: 3 }, [
        $.value > 0 ? (s(), o("div", Qe, n(f(U)(f(g).subtotal)) + " / " + n($.value), 1)) : r("", !0),
        a("div", Oe, [
          a("button", {
            class: "offset-offering-add-full",
            disabled: M.value,
            onClick: de
          }, n(M.value ? "Adding…" : "Add Full Offering to Cart"), 9, Ve)
        ]),
        a("div", We, [
          (s(!0), o(h, null, w(f(m), (e) => {
            var u, k, K;
            return s(), o("div", {
              key: e.sku,
              class: "offset-offering-product"
            }, [
              a("div", Fe, [
                a("figure", null, [
                  f(Z)(e.image) ? (s(), o("div", {
                    key: 1,
                    class: "offset-offering-image-placeholder",
                    role: "img",
                    "aria-label": e.label || e.name
                  }, i[2] || (i[2] = [
                    a("svg", {
                      viewBox: "0 0 24 24",
                      width: "25%",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.5"
                    }, [
                      a("rect", {
                        x: "3",
                        y: "3",
                        width: "18",
                        height: "18",
                        rx: "2"
                      }),
                      a("circle", {
                        cx: "8.5",
                        cy: "8.5",
                        r: "1.5"
                      }),
                      a("path", { d: "M21 15l-5-5L5 21" })
                    ], -1)
                  ]), 8, Ie)) : (s(), o("img", {
                    key: 0,
                    src: e.image_medium || e.image,
                    alt: e.label || e.name,
                    loading: "lazy",
                    decoding: "async"
                  }, null, 8, Te))
                ])
              ]),
              a("div", Pe, [
                e.product_badge ? (s(), o("div", Re, n(e.product_badge), 1)) : r("", !0),
                a("h3", Be, [
                  W(n(e.label || e.name) + " ", 1),
                  e.subtitle ? (s(), o("small", ze, n(e.subtitle), 1)) : r("", !0)
                ]),
                e.description ? (s(), o("div", {
                  key: 1,
                  class: "offset-offering-description",
                  innerHTML: e.description
                }, null, 8, Ae)) : r("", !0),
                e.additional_description ? (s(), o(h, { key: 2 }, [
                  L.value[e.sku] ? (s(), o("div", {
                    key: 0,
                    class: "offset-offering-additional",
                    innerHTML: e.additional_description
                  }, null, 8, Ne)) : r("", !0),
                  a("button", {
                    class: "offset-offering-read-more",
                    onClick: (l) => ce(e.sku)
                  }, n(L.value[e.sku] ? "Read Less" : "Read More"), 9, De)
                ], 64)) : r("", !0),
                e.stock_status_message ? (s(), o("div", He, n(e.stock_status_message), 1)) : r("", !0),
                a("table", Ee, [
                  i[4] || (i[4] = a("thead", null, [
                    a("tr", null, [
                      a("th", null, "Format"),
                      a("th", null, "Price"),
                      a("th", null, "Purchase"),
                      a("th", null, "Wish"),
                      a("th")
                    ])
                  ], -1)),
                  a("tbody", null, [
                    a("tr", null, [
                      a("td", null, [
                        e.bottle_count > 1 ? (s(), o("span", je, n(e.bottle_count) + "× ", 1)) : r("", !0),
                        W(" " + n(e.bottle_size_display || e.bottle_size), 1)
                      ]),
                      a("td", null, n(f(U)(e.price)), 1),
                      a("td", null, [
                        e.max_purchasable <= 0 ? (s(), o("span", Ge, n(e.not_available_message || "n/a"), 1)) : (s(), O(D, {
                          key: 1,
                          class: "offset-offering-qty-select",
                          "aria-label": `Quantity for ${e.sku}`,
                          "model-value": (u = d.value[e.sku]) != null ? u : 0,
                          "onUpdate:modelValue": (l) => J(e.sku, l, e.max_purchasable)
                        }, {
                          default: V(() => {
                            var l;
                            return [
                              (s(!0), o(h, null, w(z(Math.max(e.max_purchasable, (l = d.value[e.sku]) != null ? l : 0)), (c) => (s(), o("option", {
                                key: c,
                                value: c
                              }, n(B(c, e.max_purchasable)), 9, Je))), 128))
                            ];
                          }),
                          _: 2
                        }, 1032, ["aria-label", "model-value", "onUpdate:modelValue"]))
                      ]),
                      a("td", null, [
                        e.max_wish > 0 && ((k = d.value[e.sku]) != null ? k : 0) >= e.max_purchasable ? (s(), o("div", Ke, [
                          y(D, {
                            class: "offset-offering-qty-select",
                            "aria-label": `Wish quantity for ${e.sku}`,
                            "model-value": (K = x.value[e.sku]) != null ? K : 0,
                            "onUpdate:modelValue": (l) => ue(e.sku, l, e.max_wish)
                          }, {
                            default: V(() => {
                              var l;
                              return [
                                (s(!0), o(h, null, w(z(Math.max(e.max_wish, (l = x.value[e.sku]) != null ? l : 0)), (c) => (s(), o("option", {
                                  key: c,
                                  value: c
                                }, n(B(c, e.max_wish)), 9, Xe))), 128))
                              ];
                            }),
                            _: 2
                          }, 1032, ["aria-label", "model-value", "onUpdate:modelValue"]),
                          f(oe)[e.sku] ? (s(), o("div", {
                            key: 0,
                            class: "offset-offering-saving",
                            role: "status",
                            "aria-label": `Updating wish quantity for ${e.sku}`
                          }, [
                            y(q)
                          ], 8, Ye)) : r("", !0)
                        ])) : r("", !0)
                      ]),
                      a("td", null, [
                        f(E)[e.sku] ? (s(), o("div", {
                          key: 0,
                          class: "offset-offering-saving",
                          role: "status",
                          "aria-label": `Updating cart for ${e.sku}`
                        }, [
                          y(q)
                        ], 8, Ze)) : r("", !0)
                      ])
                    ]),
                    (s(!0), o(h, null, w(e.variants, (l) => {
                      var c;
                      return s(), o("tr", {
                        key: l.sku
                      }, [
                        a("td", null, [
                          l.bottle_count > 1 ? (s(), o("span", et, n(l.bottle_count) + "× ", 1)) : r("", !0),
                          W(" " + n(l.bottle_size_display || l.bottle_size), 1)
                        ]),
                        a("td", null, n(f(U)(l.price)), 1),
                        a("td", null, [
                          l.max_quantity <= 0 ? (s(), o("span", tt, n(l.not_available_message || "n/a"), 1)) : (s(), O(D, {
                            key: 1,
                            class: "offset-offering-qty-select",
                            "aria-label": `Quantity for ${l.sku}`,
                            "model-value": (c = d.value[l.sku]) != null ? c : 0,
                            "onUpdate:modelValue": (Q) => J(l.sku, Q, l.max_quantity)
                          }, {
                            default: V(() => {
                              var Q;
                              return [
                                (s(!0), o(h, null, w(z(Math.max(l.max_quantity, (Q = d.value[l.sku]) != null ? Q : 0)), (A) => (s(), o("option", {
                                  key: A,
                                  value: A
                                }, n(B(A, l.max_quantity)), 9, st))), 128))
                              ];
                            }),
                            _: 2
                          }, 1032, ["aria-label", "model-value", "onUpdate:modelValue"]))
                        ]),
                        i[3] || (i[3] = a("td", null, null, -1)),
                        a("td", null, [
                          f(E)[l.sku] ? (s(), o("div", {
                            key: 0,
                            class: "offset-offering-saving",
                            role: "status",
                            "aria-label": `Updating cart for ${l.sku}`
                          }, [
                            y(q)
                          ], 8, at)) : r("", !0)
                        ])
                      ]);
                    }), 128))
                  ])
                ])
              ])
            ]);
          }), 128))
        ]),
        $.value > 0 ? (s(), o("div", ot, [
          f(se).enable_promo ? (s(), O(Ue, { key: 0 })) : r("", !0),
          a("div", it, [
            a("div", null, "Subtotal (" + n($.value) + ")", 1),
            f(H) ? (s(), o("div", lt, [
              y(q)
            ])) : (s(), o("div", nt, n(f(U)(f(g).subtotal)), 1))
          ]),
          f(Z)(f(g).discount) ? r("", !0) : (s(), o("div", ft, [
            i[5] || (i[5] = a("div", null, "Discount", -1)),
            f(H) ? (s(), o("div", rt, [
              y(q)
            ])) : (s(), o("div", ut, n(f(U)(f(g).discount * -1)), 1))
          ])),
          i[7] || (i[7] = a("div", { class: "offset-offering-summary-note" }, " Tax & Shipping: Calculated at Checkout ", -1)),
          a("div", dt, [
            y(qe, {
              onClick: i[0] || (i[0] = (e) => re(v.value))
            }, {
              default: V(() => i[6] || (i[6] = [
                W("Continue", -1)
              ])),
              _: 1,
              __: [6]
            })
          ])
        ])) : r("", !0)
      ], 64)) : (s(), o("div", $e, "No offering available."))
    ], 512));
  }
}, Lt = /* @__PURE__ */ Se(ct, [["__scopeId", "data-v-d6b26a03"]]);
export {
  Lt as O
};
